module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "portfolio"
    }
  }, [_c('navigation', {
    staticClass: "absolute",
    attrs: {
      "dark": true
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.portfolio), function(item) {
    return _c('div', {
      staticClass: "portfolio-list",
      style: ({
        'background-image': 'url(/dist/' + item.backdrop + ')'
      })
    }, [_c('div', {
      staticClass: "description"
    }, [_c('div', {
      staticClass: "wrapper"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "scope"
    }, _vm._l((item.scope), function(scope) {
      return _c('h4', [_vm._v(_vm._s(scope))])
    })), _vm._v(" "), _c('a', {
      staticClass: "button",
      attrs: {
        "href": '/portfolio/' + item.id
      }
    }, [_vm._v("Case Study")])])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdf0cca8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/portfolio.vue
// module id = 160
// module chunks = 0